import React from 'react';
import i18n from '../../i18n';

class CursorTooltip extends React.Component {
    tooltipsTexts = {
        select: i18n.t('global:textSelectTooltip'),
        click: i18n.t('global:clickTooltip')
    }

    render() {
        const {cursorTooltipRef, tooltipTextKey} = this.props;

        return (
            <div
                className={"CursorTooltip " + tooltipTextKey}
                ref={cursorTooltipRef}>
                {this.tooltipsTexts[tooltipTextKey]}
            </div>
        )
    }
}

export default CursorTooltip;